/*
 * Kalmix custom code
 * File: assets/kmx-ntrip-index.js
 * Version: 1023.1
 * History:
 * - 1023.1 03: the fold starts from a clean row (marker and row title reset) so one pass is final;
 *   one left-over code is shown, never '+1', unless it truly cannot fit (narrow screens);
 *   +N is a button that opens the full list on click / tap / Enter (touch has no hover).
 *   04: the two step tabs work with the keyboard (Left / Right / Home / End).
 * - 1021.1 03: a +N marker created by the fold keeps its own (empty) name list, so running the fold
 *   again (fonts ready, resize) no longer repeats the folded names in its hover text.
 * - 1013.4 03: never show '+1'; a single extra code is shown (or, if it cannot fit,
 *   left out with the name in the row tooltip); two or more become +N.
 * - 1013.3 03: no more act growth or +N expansion; the list fits one screen by CSS and
 *   scrolls inside the act on short screens; the selected state's row is scrolled
 *   into view inside the list.
 * - 1013.2 04: steps switch by class (is-on / aria-hidden / inert) instead of hidden, so
 *   both panels keep their place and the card height stays fixed.
 * - 1013.1 04: two-step switch (set up the client / check the stream) in one band;
 *   step 2 lights SINGLE → FLOAT → FIXED; on first view the band moves on to step 2
 *   once after ~3 s unless the visitor already picked a step; the act is re-measured
 *   after a switch.
 * - 1012.5 04: the status lights in the new field band (.nx-band).
 * - 1012.4 04: the status line of the example NTRIP client lights SINGLE, FLOAT,
 *   FIXED in turn once, when the card comes into view (final state at once with
 *   reduced motion).
 * - 1012.3 Zero review 1012: 04 is sized against everything below it (footer and
 *   the bottom legal row), not only the footer group. 03: +N opens the rest of a
 *   state's services; if the list does not fit one screen the act grows (.is-tall)
 *   instead of clipping.
 * - 1012.2 04 CONNECT: sizes the act to one screen minus the site footer group
 *   (measured, re-measured on resize and footer changes; floor from data-floor),
 *   so the last act and the footer share one snapped screen as on the homepage.
 *   When the content does not fit it switches to the compact layout (.is-tight),
 *   and if that is still too tall the act grows instead of clipping.
 * - 1012.1 Initial delivery for CAIRN 02 COMPARE and 03 STATES. The rows are server
 *   HTML (snippet kmx-ntrip-index); this script only enhances them: fee and state
 *   filters, state-aware order (same rule as the map panel, via window.KMX_NM when
 *   01 LOCATE is on the page), one open detail row at a time, #provider-<slug> links
 *   from the map panel and 03 open and flash the row, and the 03 row of the state
 *   selected on the map is highlighted. Loaded by both sections; runs once.
 */
(function () {
  'use strict';
  if (window.KMX_NX) return;
  window.KMX_NX = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var cmp = document.querySelector('.kmx-nx-compare');
    var sts = document.querySelector('.kmx-nx-states');
    var feeF = 'all', stF = '';

    if (cmp) {
      var tbody = cmp.querySelector('.nx-tbl tbody');
      var wrap = cmp.querySelector('.nx-tblwrap');
      var cnt = cmp.querySelector('.nx-cnt');
      var sel = cmp.querySelector('.nx-stsel');
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('.nx-row'));
      var det = function (r) { return document.getElementById(r.querySelector('.nx-open').getAttribute('aria-controls')); };
      var nameOf = {};
      if (sel) Array.prototype.forEach.call(sel.options, function (o) { if (o.value) nameOf[o.value] = o.textContent; });

      function close(r) { r.classList.remove('is-open'); r.querySelector('.nx-open').setAttribute('aria-expanded', 'false'); det(r).hidden = true; }
      function open(r, flash) {
        rows.forEach(function (x) { if (x !== r) close(x); });
        r.classList.add('is-open'); r.querySelector('.nx-open').setAttribute('aria-expanded', 'true'); det(r).hidden = false;
        if (flash) { r.classList.remove('is-flash'); void r.offsetWidth; r.classList.add('is-flash'); }
      }
      rows.forEach(function (r) {
        r.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          if (r.classList.contains('is-open')) close(r); else open(r);
        });
      });

      function apply() {
        var score = null;
        if (stF && window.KMX_NM && window.KMX_NM.covScore) score = function (r) { return window.KMX_NM.covScore(r.getAttribute('data-id'), stF); };
        var list = rows.slice().sort(function (a, b) {
          var ga = { free: 0, cond: 1, paid: 2 }[a.getAttribute('data-g')], gb = { free: 0, cond: 1, paid: 2 }[b.getAttribute('data-g')];
          if (score && ga !== gb) return ga - gb;
          if (score) { var d = score(b) - score(a); if (d) return d; }
          return a.getAttribute('data-o') - b.getAttribute('data-o');
        });
        var n = 0;
        list.forEach(function (r) {
          var on = (feeF === 'all' || r.getAttribute('data-g') === feeF) && (!stF || (' ' + r.getAttribute('data-st') + ' ').indexOf(' ' + stF + ' ') >= 0);
          r.hidden = !on; if (!on) close(r); else n++;
          tbody.appendChild(r); tbody.appendChild(det(r));
        });
        cnt.textContent = n + ' provider' + (n === 1 ? '' : 's') + (stF ? ' serving ' + (nameOf[stF] || stF) : '');
      }
      cmp.querySelectorAll('.nx-seg button').forEach(function (b) {
        b.addEventListener('click', function () {
          feeF = b.getAttribute('data-f');
          cmp.querySelectorAll('.nx-seg button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          apply();
        });
      });
      if (sel) sel.addEventListener('change', function () { stF = sel.value; apply(); });
      // the map's own scoring arrives a moment later; re-sort if a state filter is already set
      if (window.KMX_NM && window.KMX_NM.ready) window.KMX_NM.ready.then(function () { if (stF) apply(); });

      // #provider-<slug>: from the map panel, from 03 and from shared links
      function goProvider(slug, smooth) {
        var r = document.getElementById('provider-' + slug);
        if (!r || !r.classList.contains('nx-row')) return false;
        if (r.hidden) { feeF = 'all'; stF = ''; if (sel) sel.value = ''; cmp.querySelectorAll('.nx-seg button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-f') === 'all')); }); apply(); }
        cmp.scrollIntoView({ behavior: reduce || !smooth ? 'auto' : 'smooth', block: 'start' });
        open(r, true);
        // bring the row near the top of the table box, under the sticky header
        setTimeout(function () { wrap.scrollTop = r.offsetTop - 40; }, reduce || !smooth ? 0 : 450);
        return true;
      }
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#provider-"]');
        if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
        if (goProvider(a.getAttribute('href').slice(10), true)) {
          e.preventDefault();
          try { history.pushState(history.state, '', a.getAttribute('href')); } catch (err) {}
        }
      });
      var h = decodeURIComponent(location.hash || '');
      if (h.indexOf('#provider-') === 0) setTimeout(function () { goProvider(h.slice(10), false); }, 300);
    }

    // 04 CONNECT: two steps in one band (set up the client / check the stream)
    var band = document.querySelector('.nx-band');
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.nx-steps2 [role="tab"]'));
    if (band && tabs.length) {
      var timers = [], touched = false;
      var lights = function () {
        timers.forEach(clearTimeout); timers = [];
        band.classList.remove('is-s1', 'is-s2', 'is-s3');
        if (reduce) { band.classList.add('is-s3'); return; }
        timers.push(setTimeout(function () { band.classList.add('is-s1'); }, 250));
        timers.push(setTimeout(function () { band.classList.add('is-s2'); }, 1000));
        timers.push(setTimeout(function () { band.classList.add('is-s3'); }, 1750));
      };
      var show = function (n) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-step') === String(n);
          t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
          // both panels stay in place (same grid cell); only visibility changes, so nothing jumps
          var pnl = document.getElementById(t.getAttribute('aria-controls'));
          pnl.classList.toggle('is-on', on);
          if (on) { pnl.removeAttribute('aria-hidden'); pnl.removeAttribute('inert'); } else { pnl.setAttribute('aria-hidden', 'true'); pnl.setAttribute('inert', ''); }
        });
        band.setAttribute('data-step', n);
        if (String(n) === '2') lights();
        if (window.KMX_NX_FIT) window.KMX_NX_FIT();
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { touched = true; show(t.getAttribute('data-step')); });
        // keyboard: Left / Right / Home / End move between the steps (WAI-ARIA tabs)
        t.addEventListener('keydown', function (e) {
          var j = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: tabs.length - 1 }[e.key];
          if (j === undefined) return;
          e.preventDefault(); touched = true; j = (j + tabs.length) % tabs.length;
          show(tabs[j].getAttribute('data-step')); tabs[j].focus();
        });
      });
      // first visit: show step 1, then move on to step 2 once, unless the visitor already chose
      if (window.IntersectionObserver && !reduce) {
        var bio = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          bio.disconnect();
          setTimeout(function () { if (!touched) show(2); }, 3200);
        }, { threshold: .6 });
        bio.observe(band);
      }
    }

    // 04 CONNECT: the act plus everything below it (footer, bottom legal row) = one screen
    var con = document.querySelector('.kmx-nx-connect');
    if (con) {
      var floor = parseFloat(con.getAttribute('data-floor')) || 480;
      var fitting = false;
      var fit = function () {
        if (fitting) return; fitting = true;
        con.style.setProperty('--nx-floor', floor + 'px');
        var below = Math.max(0, document.documentElement.scrollHeight - (con.getBoundingClientRect().bottom + window.scrollY));
        var h = Math.round(Math.max(floor, window.innerHeight - below));
        con.style.setProperty('--nx-h', h + 'px');
        // too little room: compact first, then grow the act rather than clip it
        var inner = con.querySelector('.nx-cinner');
        con.classList.remove('is-tight');
        if (window.innerWidth > 1100 && inner) {
          if (inner.scrollHeight > inner.clientHeight + 1) con.classList.add('is-tight');
          if (inner.scrollHeight > inner.clientHeight + 1) con.style.setProperty('--nx-h', (h + inner.scrollHeight - inner.clientHeight) + 'px');
        }
        fitting = false;
      };
      window.KMX_NX_FIT = fit;
      fit();
      window.addEventListener('resize', fit); window.addEventListener('load', fit);
      // late images change the content height: measure again when they land
      con.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', fit); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { requestAnimationFrame(fit); });
        var n = con.parentElement; // observe every block after the act (section wrappers, footer groups, legal row)
        while (n && n !== document.body) { var sib = n.nextElementSibling; while (sib) { ro.observe(sib); sib = sib.nextElementSibling; } n = n.parentElement; }
      }
    }

    if (sts) {
      // 03 fits one screen by CSS (rows 22–34 px); on shorter screens the list scrolls inside the act
      // one line per state: codes that do not fit the row are folded into the +N count
      var fold = function () {
        sts.querySelectorAll('.nx-ids').forEach(function (box) {
          var chips = Array.prototype.slice.call(box.querySelectorAll('.nx-id'));
          var more = box.querySelector('.nx-more');
          // the generator's own +N keeps its count and names in data-*; a marker made here starts empty
          if (more && !more.hasAttribute('data-base')) {
            more.setAttribute('data-base', more.textContent.replace('+', ''));
            more.setAttribute('data-names', (more.getAttribute('title') || '').replace(/^Also: /, ''));
          }
          var base = more ? parseInt(more.getAttribute('data-base'), 10) || 0 : 0;
          var baseNames = more ? more.getAttribute('data-names') : '';
          // clean start: every code visible, marker visible with its own count, no row title
          chips.forEach(function (c) { c.hidden = false; });
          box.removeAttribute('title');
          if (more) { if (base) { more.hidden = false; more.textContent = '+' + base; } else more.remove(); more = base ? more : null; }
          var hidden = [];
          var mk = function () {
            if (!more) { more = document.createElement('button'); more.type = 'button'; more.className = 'nx-more'; more.setAttribute('data-base', '0'); more.setAttribute('data-names', ''); more.setAttribute('aria-expanded', 'false'); box.appendChild(more); }
            var names = hidden.concat(baseNames ? baseNames.split(', ') : []).join(', ');
            more.textContent = '+' + (hidden.length + base); more.title = 'Also: ' + names; more.setAttribute('aria-label', 'Also: ' + names);
          };
          for (var i = chips.length - 1; i >= 0 && box.scrollWidth > box.clientWidth + 1; i--) {
            chips[i].hidden = true; hidden.unshift(chips[i].title.split(' · ')[0]); mk();
          }
          // never '+1': a single folded code comes back if it fits without the marker
          if (more && hidden.length === 1 && !base) {
            more.hidden = true; chips[chips.length - 1].hidden = false;
            if (box.scrollWidth > box.clientWidth + 1) { chips[chips.length - 1].hidden = true; more.hidden = false; }
            else { more.remove(); more = null; }
          }
        });
      };
      // +N opens the full list (click, tap, Enter); hover titles do not exist on touch screens
      var pop = null;
      var closePop = function () { if (pop) { pop.remove(); pop = null; } sts.querySelectorAll('.nx-more[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); };
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.kmx-nx-states .nx-more');
        if (!b) { if (pop && !(e.target.closest && e.target.closest('.nx-morelist'))) closePop(); return; }
        e.preventDefault();
        var was = b.getAttribute('aria-expanded') === 'true'; closePop(); if (was) return;
        pop = document.createElement('div'); pop.className = 'nx-morelist'; pop.setAttribute('role', 'note');
        pop.textContent = (b.getAttribute('title') || '').replace(/^Also: /, 'Also: ');
        (b.closest('.nx-srow') || b.parentNode).appendChild(pop); b.setAttribute('aria-expanded', 'true');
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
      fold();
      var foldT; window.addEventListener('resize', function () { clearTimeout(foldT); foldT = setTimeout(fold, 120); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fold);
      // highlight the state selected on the map
      document.addEventListener('kmx-nm:state', function (e) {
        var a = e.detail && e.detail.state;
        sts.querySelectorAll('.nx-srow').forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-st') === a); });
        var on = sts.querySelector('.nx-srow.is-on'), sw = sts.querySelector('.nx-swrap');
        if (on && sw && sw.scrollHeight > sw.clientHeight) sw.scrollTop = on.offsetTop - sw.clientHeight / 2;
      });
      if (window.KMX_NM && window.KMX_NM.active) {
        var a0 = window.KMX_NM.active();
        sts.querySelectorAll('.nx-srow').forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-st') === a0); });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
